// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-grid-container----styles-module---container---2DYx-","fullWidth":"src-components-grid-container----styles-module---fullWidth---PdYEy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grid-container/styles.module.css
// module id = 626
// module chunks = 168707334958949